<template>
  <v-dialog v-model="dialog" max-width="800px" fullscreen scrollable>
    <v-card>
      <v-card-title>
        <span class="headline">Modifica Contabile</span>
      </v-card-title>
      <v-card-text>
        <v-form v-model="valid" ref="form">
          <v-row>
            <v-col cols="12" class="headline">
              <v-icon class="mr-2">mdi-account</v-icon>{{ cliente.nome }}
            </v-col>
            <v-col cols="8">
              <v-menu
                ref="menu"
                v-model="menu_data"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dataFormatted"
                    label="Data"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu_data = false">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(date)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="4" class="d-flex align-center">
              {{ contabile.tipo == 1 ? "Debito" : "Credito" }}
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                prepend-inner-icon="mdi-cash"
                prefix="€"
                v-model="importo"
                label="Importo"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-switch v-model="verde" label="Verde" inset></v-switch>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                prepend-inner-icon="mdi-clipboard-list"
                :items="listaOrdini"
                item-text="numero"
                item-value="_id.$oid"
                v-model="ordine"
                label="Ordine"
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-if="!verde"
                prepend-inner-icon="mdi-file-document"
                v-model="ddt"
                label="Ddt"
                outlined
                :rules="[
                  !verde
                    ? (v) => !!v || 'Inserisci un documento di trasporto'
                    : '',
                ]"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="note"
                label="Note"
                outlined
                rows="1"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="grey" text @click="dialog = false">Annulla</v-btn>
        <v-btn
          color="primary"
          outlined
          :loading="loadingSalva"
          @click="salvaContabile"
          :disabled="!valid"
          ><v-icon class="mr-2">mdi-floppy</v-icon>Salva</v-btn
        >
      </v-card-actions>
      <v-snackbar v-model="errorDialog" color="error" timeout="2000">
        <v-icon class="mr-2">mdi-alert</v-icon># DDT o Ordine già esistente
      </v-snackbar>
    </v-card>
  </v-dialog>
</template>
  
<script>
import modifica_contabile_mixin from "../mixin/modifica_contabile_mixin";

export default {
  mixins: [modifica_contabile_mixin],
  methods: {
    open() {
      this.dialog = true;
    },
  },
};
</script>